import request from 'sb-request/graphql'

import couponApplyQuery from './couponApply.graphql'

import type { CouponApplyPayload, CouponApplyVariables } from './couponApplyGQL'


export type ApplyCouponResult = {
  data: CouponApplyPayload['couponApply']['data']['coupon']
  error: { code: string, message: string }
}

type CouponApplyVariablesType = CouponApplyVariables & {
  validateOnly: boolean
}


export const applyCoupon = (input: CouponApplyVariables['input']): Promise<ApplyCouponResult> =>
  request<CouponApplyVariablesType, CouponApplyPayload, ApplyCouponResult>('couponApply', {
    query: couponApplyQuery,
    variables: {
      input,
      validateOnly: Boolean(input.validateOnly),
    },
  }, {
    modifyResult: ({ couponApply: { data, error } }) => ({
      data: data && data.coupon,
      error,
    }),
  })


export const getCouponData = (input: CouponApplyVariables['input']): Promise<ApplyCouponResult> =>
  applyCoupon({ ...input, validateOnly: true })
